import React, { useEffect, useRef, useState } from "react";
import { BACKEND_URL } from "../../../constants"
import { useParams } from "react-router-dom"
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css'
import SectionMagazineSubCategory4 from "components/Sections/SectionMagazineSubCategory4"
import cogoToast from "cogo-toast"

const PageSubCategory = () => {
  const [data,setData] = useState([])
  const initialized = useRef(false);
  const params = useParams()

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      fetch(`${BACKEND_URL}/articles`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((response) => {
          if (!response.hasOwnProperty("error")) {
           setData(response)
          }
        })
        .catch((error) => {
          console.error("error: ", error);
        })
        .finally(() => {
          console.log("finally")
        })
    }
  }, []);
  
  return (
    <div style={{paddingTop:"13px"}} className={`nc-PageArchiveAudio `}>

      <div className="container lg:pb-28 space-y-16 lg:space-y-28">
        <div>
          {/* <div className="flex flex-col sm:items-center sm:justify-between sm:flex-row">
            <div className="block my-4 border-b w-full border-neutral-300 dark:border-neutral-500 sm:hidden"></div>
          </div> */}

          {/* LOOP ITEMS */}
          <SectionMagazineSubCategory4
            category={params.category}
            heading={ params.subcategory === "swiat" ? "Świat": `${params.subcategory[0].toUpperCase()}${params.subcategory.slice(1)}`}
            category_id={params.subcategory_id}
            subcategory_id={params.category_id}
            subcategory={params.subcategory}
            posts={data}
          />
        </div>
        {/* <div className="relative py-16">
          <BackgroundSection />
        </div> */}

      </div>
    </div>
  );
};

export default PageSubCategory;
